import { transformDateValue } from 'core/js/FormUtils';
export const getPoView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let poList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Party Name","fieldValue":transformDataValue(data.partyname,"string"), "fieldType":"string"},
                            {"fieldLabel":"PO Value","fieldValue":transformDataValue(data.povalue,"double"), "fieldType":"double"},
              
              
            ],
            'dataList': [
                              {"fieldLabel":"PO Date","fieldValue":transformDataValue(data.podate,"date"), "fieldType":"date"},
                            {"fieldLabel":"Order Value","fieldValue":transformDataValue(data.ordervalue,"double"), "fieldType":"double"},
              
              ]
          }

          poList.push(card);
  })
  return poList;
}